<script lang="ts" setup>
const value = defineModel<boolean>({ default: false });

withDefaults(
  defineProps<{
    disabled?: boolean;
    label?: string;
  }>(),
  {
    label: undefined,
  },
);
</script>

<template>
  <label class="relative inline-flex items-center" data-testid="base-switch">
    <input
      v-model="value"
      type="checkbox"
      class="peer sr-only"
      data-testid="bs-checkbox"
      :disabled="disabled"
    />
    <div
      class="relative box-border inline-block h-[16px] w-[28px] cursor-pointer rounded-full border border-neutral outline-offset-2 transition-colors duration-75 peer-focus-visible:outline-2"
      :class="[
        modelValue ? 'border-strong-primary bg-strong-primary-muted' : 'bg-neutral',
        {
          'cursor-not-allowed opacity-50': disabled,
        },
      ]"
      data-testid="bs-switch"
    >
      <div
        class="absolute top-[-1px] left-[-1px] box-border h-[16px] w-[16px] rounded-full border border-neutral bg-default transition-transform duration-75 [:checked+div>&]:translate-x-[12px]"
        :class="{ 'border-strong-primary': modelValue }"
      />
    </div>
    <span v-if="label" class="ml-1.5x font-medium" :class="{ 'text-neutral-disabled': disabled }">
      {{ label }}
    </span>
  </label>
</template>
